import { createFileRoute } from "@tanstack/react-router"
import { KlaviyoAuthModal } from "modules/settings/components/integrations/klaviyo/KlaviyoAuthModal"

export const Route = createFileRoute("/_base/_auth/settings/integrations/klaviyo/connect")({
  component: KlaviyoAuthModal,
})
